import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const team = [
  { name: "David Bushayija", role: "CEO", image: "https://placehold.co/400x400" },
  { name: "Cedric Byishimo", role: "Designer", image: "/img/Cedric.png" },
  { name: "Olivier Uwitonze", role: "Engineer", image: "https://placehold.co/400x400" },
  { name: "Osborne Rutabangama", role: "Marketing", image: "https://placehold.co/400x400" },
];

const TeamPremium = () => {
  const sectionRef = useRef(null);

  useGSAP(
    () => {
      gsap.utils.toArray(".team-card").forEach((card) => {
        const image = card.querySelector(".team-image");
        const copy = card.querySelector(".team-copy");

        gsap.to(image, {
          yPercent: 18,
          ease: "none",
          scrollTrigger: {
            trigger: card,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        });

        gsap.from(copy, {
          y: 28,
          opacity: 0,
          duration: 0.7,
          scrollTrigger: {
            trigger: card,
            start: "top 80%",
          },
        });
      });
    },
    { scope: sectionRef }
  );

  return (
    <section id="team" ref={sectionRef} className="relative bg-slate-950 py-24 sm:py-28">
      <div className="section-shell">
        <div className="section-title">
          <p className="section-kicker">Our Team</p>
          <h2 className="section-heading">People behind the precision</h2>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
          {team.map((member) => (
            <article key={member.name} className="team-card glass-card overflow-hidden">
              <div className="relative h-64 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-image h-full w-full scale-110 object-cover"
                />
              </div>
              <div className="team-copy p-5">
                <h3 className="text-lg font-semibold text-white">{member.name}</h3>
                <p className="mt-1 text-sm text-amber-400">{member.role}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamPremium;
